import React, { Component } from 'react';
import { Snackbar } from '@material-ui/core';

class NotificationPopup extends Component {
  render() {
    const { isOpen, onClose, message, autoHideDuration = 5000 } = this.props;

    return (
      <Snackbar
        open={isOpen}
        autoHideDuration={autoHideDuration}
        onClose={onClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        message={message}
      />
    )
  }
}

export default NotificationPopup;
